import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Ban, CheckCircle } from "lucide-react";
import SectionCard from "features/TraxxionProfile/components/SectionCard";
import JobInformation from "../../../../features/TraxxionProfile/sections/JobAndPay/JobInformation";
import Compensation from "../../../../features/TraxxionProfile/sections/JobAndPay/Compensation";
import Organization from "../../../../features/TraxxionProfile/sections/JobAndPay/Organization";
import { getSecondaryResources } from "../../../../utils/helpers/user";
import { renderSettingsResourceLabel } from "../../../../utils/helpers/settings";

function JobAndPay({ user }: any) {
    const { t } = useTranslation();

    const secondaryJobs = useMemo(
        () => getSecondaryResources(user?.jobs || []),
        [user?.jobs]
    );

    const renderStatus = useCallback((status: string) => {
        switch (status) {
            case "active":
                return (
                    <div className="tw-flex tw-items-center tw-text-green-700 tw-font-bold tw-gap-3">
                        {t("active")}
                        <CheckCircle size={17} />
                    </div>
                );
            case "inactive":
                return (
                    <div className="tw-flex tw-items-center tw-text-rose-500 tw-font-bold tw-gap-3">
                        {t("inactive")}
                        <Ban size={17} />
                    </div>
                );
            case "pending":
                return (
                    <span className="tw-text-neutral-500 tw-font-bold">
                        {t("pending") + "..."}
                    </span>
                );
        }
    }, [t]);

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <JobInformation user={user} />
            <Compensation user={user} />
            <Organization user={user} />

            {secondaryJobs?.length > 0 && (
                <SectionCard title={t("secondary-job")}>
                    {secondaryJobs.map((job: any) => (
                        <div key={job.id} className="tw-flex tw-items-center tw-justify-between tw-py-2 tw-border-b last:tw-border-b-0 tw-text-sm">
                            <span>{renderSettingsResourceLabel(job)}</span>
                            <span>{renderStatus(job?.status)}</span>
                        </div>
                    ))}
                </SectionCard>
            )}
        </div>
    );
}

export default JobAndPay;
